import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import img1 from "../image/courses1.png";
import img2 from "../image/courses2.png";
import img3 from "../image/courses3.jpg";
import img4 from "../image/Courses4.jpg";
import { URL } from "../Redux/common/url";

const courses = [
  {
    name: "Gemstone Diamond Ring – Elegant Sparkle with Precious",
    discountPrice: "9999",
    originalPrice: "10000",
    img: img1,
    link: "/",
  },
  {
    name: "Elegant Green Gemstone and Diamond Necklace Set",
    discountPrice: "9999",
    originalPrice: "10000",
    img: img2,
    link: "/",
  },
  {
    name: "Diamond & White Gold Necklace Set – Luxury Jewelry for Women",
    discountPrice: "9999",
    originalPrice: "10000",
    img: img3,
    link: "/",
  },
  {
    name: "Elegant Women's Diamond Ring – Timeless Luxury & Sparkling Beauty",
    discountPrice: "9999",
    originalPrice: "10000",
    img: img4,
    link: "/",
  },
];

function OurCourses() {
  const get_product_list = useSelector((state) =>
    state?.allapi?.user_product_search ? state?.allapi?.user_product_search : {}
  );

  const listdata = get_product_list?.docs ? get_product_list?.docs : [];
  console.log(listdata);

  useEffect(() => {
    const cards = document.querySelectorAll(".featured-product-card");
    cards.forEach((card) => {
      const field = document.createElement("div");
      field.className = "featured-particles-field";
      card.appendChild(field);

      for (let i = 0; i < 25; i++) {
        const particle = document.createElement("div");
        particle.className = "featured-particle";
        particle.style.setProperty("--x", `${Math.random() * 200 - 100}px`);
        particle.style.setProperty("--y", `${Math.random() * 200 - 100}px`);
        particle.style.animation = `particleFloat ${
          1 + Math.random() * 2
        }s infinite ease-in-out`;
        particle.style.animationDelay = `${Math.random() * 2}s`;
        particle.style.left = `${Math.random() * 100}%`;
        particle.style.top = `${Math.random() * 100}%`;
        field.appendChild(particle);
      }
    });
  }, []);

  return (
    <div className="featured-product-slider-container px-1 mt-4 feature-product-new">
      <div className="featured-product-header position-relative overflow-hidden d-flex justify-content-between align-items-center p-2 mb-2">
        <div>
          <h5 className="fw-bold featured-product-text mb-0">OUR COURSES</h5>
        </div>
        <div>
          {/* ✅ Fixed here: to="/" instead of empty string */}
          <Link
            className="text-decoration-none fw-bold featured-product-text"
            to="/courses"
          >
            View all
          </Link>
        </div>

        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
      </div>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={15}
        autoplay={{ delay: 1800, disableOnInteraction: false }}
        loop={true}
        speed={1000}
        breakpoints={{
          320: { slidesPerView: 2 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 6 },
        }}
      >
        {listdata?.map((c, i) => (
          <SwiperSlide key={i}>
            {/* ✅ Fixed here: added to="/" so Link always has a valid path */}
            <Link to="/" className="text-decoration-none">
              <div className="featured-product-card tilt">
                <div className="img-box">
                 <img
                                    src={URL?.API_BASE_URL + c.image}
                                    className="card-img-top"
                                    alt={c.name}
                                    style={{ height: "180px", objectFit: "cover" }}
                                  />
                                  <span className="badge bg-light text-dark position-absolute top-0 start-0 m-2">
                                    {c.tag}
                                  </span>
                </div>

                <span className="mannu-bhai"></span>
                <span className="mannu-bhai"></span>
                <span className="mannu-bhai"></span>
                <span className="mannu-bhai"></span>

                <div style={{ lineHeight: "0.6" }}>
                  <p>{c.name}</p>

                  <div className="d-flex align-items-center">
                    <span className="fw-bold text-success">{c.price}</span>
                    {/* <span className="text-warning fw-bold text-decoration-line-through ms-3">
                       {c.oldPrice}
                    </span> */}
                  </div>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default OurCourses;
